// This type was ported directly from the rlit app source:
// https://gitlab.com/sidekick8075033/rlit_app/-/tree/main/src/types?ref_type=heads
//

export enum NodeType {
  SENTENCE = "sentence",
  WORD = "word",
  VISEME = "viseme",
}

export type TViseme = {
  time: number
  type: NodeType.VISEME
  value: string
}

export interface Viseme {
  time: number
  type: NodeType.VISEME
  value: string
}

export type TWord = {
  time: number
  type: NodeType.WORD
  start: number
  end: number
  value: string
  children?: TViseme[]
}

export interface Word {
  time: number
  type: NodeType.WORD
  start: number
  end: number
  value: string
  visemes: Viseme[]
}

export type TSentence = {
  time: number
  type: NodeType.SENTENCE
  start: number
  end: number
  value: string
  children?: TWord[]
}

export interface Sentence {
  time: number
  type: NodeType.SENTENCE
  start: number
  end: number
  value: string
  words: Word[]
}

export type TSpeechMarks = {
  data: Array<TSentence | TWord | TViseme>
}

export type TSpeechMarksData = {
  speech_marks: Array<TSentence | TWord | TViseme>
  speech_mark_id: string
  message_id: string
  created_at: string
}
